// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import productDescriptionVariantStyles from "@sc/App/SharedStyles/ProductDescriptionStyles";
import { productCardStyles } from "@sc/Overrides/Widgets/ProductList/ProductListProductCard";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

const partNumberAndAttributeStyles = {
    css: css`
        max-width: 197px;
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};
productCardStyles.productListProductImage = {
    wrapper: {
        css: css`
            width: 120px;
            height: 120px;
            ${xScreen("lte", "md")} {
                width: 91px;
                height: 91px;
            }
        `,
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                height: 120px;
            `,
        },
    },
};
productCardStyles.gridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 120px minmax(0, 694px) 317px;
        grid-column-gap: 20px;
        padding: 16px 0;
        border-bottom: 1px solid ${getColor("common.border")};
        width: 100%;
        ${xScreen("lte", "lg")} {
            grid-template-columns: 120px minmax(0, 518px) 317px;
        }

        ${xScreen("lte", "md")} {
            border-bottom: none;
            grid-template-columns: 91px minmax(0, 1fr);
            height: 100%;
            grid-column-gap: 12px;
            padding: 12px 0;
        }
        ${xScreen("lte", 767)} {
            padding: 16px 0;
        }
    `,
};
productCardStyles.leftColumnGridItem = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 5;
    `,
};

productCardStyles.infoGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        grid-column: 2 / 3;
        grid-row: 1 / 5;
        ${xScreen("lte", "md")} {
            padding-right: 0;
        }
    `,
};
productCardStyles.actionsGridItem = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 6;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 5 / 6;
            margin-top: auto;
        }
    `,
};
productCardStyles.searchScoreDataGridItem = {
    css: css`
        grid-column: 1 / 4;
        grid-row: 6 / 7;
        min-height: 28px;
        &:empty {
            display: none;
        }

        ${xScreen("lte", "md")} {
            grid-column: 2 / 3;
        }
    `,
};

productCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                ${xScreen("lte", "md")} {
                    max-width: 100%;
                }
            `,
        },
        badges: {
            css: css`
                display: none;
            `,
        },
    },
};

productCardStyles.productPriceAndActionsTopSectionStyles = {
    productGridContainer: {
        container: {
            css: css`
                max-width: initial;
                height: auto;
            `,
        },
    },
    productAvailabilityStyles: {
        container: {
            css: css`
                .inventory-out-of-stock-pickup {
                    ${ellipsis(1)}
                }
            `,
        },
        messageText: {
            css: css`
                ${ellipsis(1)}
            `,
        },
    },
};

productCardStyles.productInformationStyles = {
    attributes: {
        container: {
            offsetCss: css`
                gap: 8px;
            `,
        },
        attributeTypeGridItem: {
            ...partNumberAndAttributeStyles,
        },
        attributeValueGridItem: {
            ...partNumberAndAttributeStyles,
        },
        attributeTypeText: {
            size: 12,
            lineHeight: "13px",
            weight: fontConfig.weight.bold,
        },
        attributeValueText: {
            size: 12,
            lineHeight: "13px",
            color: "common.ui5",
        },
    },
    partNumbersStyles: {
        container: {
            gap: 0,
            offsetCss: css`
                flex-direction: column;
            `,
        },
        customerNameGridItem: {
            ...partNumberAndAttributeStyles,
        },
        erpNumberGridItem: {
            ...partNumberAndAttributeStyles,
        },
        manufacturerItemGridItem: {
            ...partNumberAndAttributeStyles,
        },
    },
    descriptionStyles: {
        ...mergeWithCss(productDescriptionVariantStyles.medium, {
            productDetailLink: {
                css: css`
                    ${xScreen("lte", "md")} {
                        min-height: 42px;
                    }
                    ${xScreen("lte", 767)} {
                        min-height: unset;
                    }
                `,
            },
        }),
    },
};
